import { AgreementInfo } from "./services/product/agreement";

export type MeterPointType = "MPRN" | "MPAN" | string;

export interface MeterPoint {
  id: string;
  type: MeterPointType;
  identifier: string;
}

export interface MeterPointInfo extends MeterPoint {
  lastMeterReading: MeterReading | null;
  supplyStartDt: string;
  supplyEndDt: string | null;
  agreementInfo: AgreementInfo | null;
}

export interface MeterReading {
  id: string;
  meterId: string;
  registerId: string;
  readingDttm: string;
  fromDttm: string;
  receivedDttm: string;
  status: string;
  source: string;
  quality: string;
  sequenceType: string;
  unit: string;
  cumulative: string;
  consumption: string;
}

export interface Meter {
  id: string;
  identifier: string; //e.g. ELEC 1114
  registers: MeterRegister[];
}

export interface MeterRegister {
  id: string;
  identifier: string | null; // e.g. R1
  rate: string | null; //e.g, Day, Night
  unit: string; // e.g., kwh
  digits: number;
  decimalPlaces: number;
}

export const getRate = (register: MeterRegister) => {
  return register.rate || register.identifier || register.id;
};

export interface MeterPointConfig {
  id: string;
  type: MeterPointType;
  identifier: string;
  meters: Meter[];
  isHalfHourly: boolean | null;
  // true if it is a half-hourly MPAN meter point,
  // false if it is a not-half-hourly MPAN meter point or it is not a MPAN meter point,
  // null if no mpan configuration found for the meter point at the reading time
}

// Validations
export type ValidationTypes = "WARNING" | "ERROR";
export type ValidationDetail = {
  type: ValidationTypes;
  code: string;
  message: string;
};
export type ValidationFieldResult = {
  name: string;
  severity: ValidationTypes;
  message: string;
  details: ValidationDetail[] | null;
};
export type ValidationResult = {
  id: string;
  fields: ValidationFieldResult[];
};

export interface MeterValidationResult extends ValidationResult {
  severity: ValidationTypes;
  registers: ValidationResult[];
}
